/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SiteAlerteDto } from '../../models/site-alerte-dto';

export interface GetSitesAlertesTemperatureByDkCodesEmplacements$Params {
  body: Array<string>;
}

export function getSitesAlertesTemperatureByDkCodesEmplacements(
  http: HttpClient,
  rootUrl: string,
  params: GetSitesAlertesTemperatureByDkCodesEmplacements$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<SiteAlerteDto>>> {
  const rb = new RequestBuilder(rootUrl, getSitesAlertesTemperatureByDkCodesEmplacements.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SiteAlerteDto>>;
    })
  );
}

getSitesAlertesTemperatureByDkCodesEmplacements.PATH = '/v1/reportings_p1/sites_alertes/temperature';
